export default {"src":"/polygon/_next/static/media/balancer.fa41e91c.svg","height":258,"width":258};